module.exports = __webpack_public_path__ + "img/logo_white-mobile_en.e351053d.png";